var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "32px",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.0_Cadastro-do-usuario---menu-aberto",
    transform: "translate(-55.000000, -250.000000)",
    fill: "#2B2B2B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(50.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C19.418278,0 23,3.581722 23,8 C23,12.418278 19.418278,16 15,16 C10.581722,16 7,12.418278 7,8 C7,3.581722 10.581722,0 15,0 Z M15,1.3 C11.2996922,1.3 8.3,4.29969218 8.3,8 C8.3,11.7003078 11.2996922,14.7 15,14.7 C18.7003078,14.7 21.7,11.7003078 21.7,8 C21.7,4.29969218 18.7003078,1.3 15,1.3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,18 C24.627417,18 30,23.372583 30,30 L30,31.35 C30,31.7089851 29.7089851,32 29.35,32 C28.9910149,32 28.7,31.7089851 28.7,31.35 L28.7,30.3 L28.7,30.3 C28.7,24.3212984 23.9302364,19.4566348 17.9884075,19.3037074 L17.7,19.3 L12.3,19.3 C6.32129842,19.3 1.45663482,24.0697636 1.3037074,30.0115925 L1.3,30.3 L1.3,31.35 C1.3,31.7089851 1.00898509,32 0.65,32 C0.291014913,32 1.54985296e-16,31.7089851 0,31.35 L0,30 L0,30 C0,23.372583 5.372583,18 12,18 L18,18 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bcc0ed9a3371c98e4c0d91d9f55304d5.svg";
export { ForwardRef as ReactComponent };